<div class="modal-backdrop" #modalBackdrop (click)="handleBackdropClick()"></div>
<ng-template #pagesContainer></ng-template>